"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

export default function StudioDetector() {
  const pathname = usePathname();
  const isStudio = pathname.startsWith("/studio");

  useEffect(() => {
    if (isStudio) {
      document.documentElement.setAttribute("data-studio", "true");
    } else {
      document.documentElement.removeAttribute("data-studio");
    }
  }, [isStudio]);

  return null;
}
